export default __webpack_public_path__ + "static/media/usa.d21917ae.svg";